import React from "react";
import { Box, Tabs, Tab, Theme } from "@mui/material";
import { SxProps } from "@mui/system";

export type ProfileSectionType =
  | "Events"
  | "Products"
  | "Photos"
  | "Performance"
  | "Reviews"
  | "Availability";

interface ProfileSectionsProps {
  userType: "BA" | "Brand" | "Account";
  currentSection: ProfileSectionType;
  onSectionChange: (section: ProfileSectionType) => void;
  sx?: SxProps<Theme>;
}

const ProfileSections: React.FC<ProfileSectionsProps> = ({
  userType,
  currentSection,
  onSectionChange,
  sx,
}) => {
  const sections: Record<string, ProfileSectionType[]> = {
    BA: ["Events", "Performance", "Reviews", "Photos"],
    Brand: ["Events", "Products", "Photos"],
    Account: ["Events", "Availability", "Photos"],
  };

  const handleChange = (
    _: React.SyntheticEvent,
    newValue: ProfileSectionType
  ) => {
    onSectionChange(newValue);
  };

  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider", ...sx }}>
      <Tabs
        value={currentSection}
        onChange={handleChange}
        aria-label="profile sections"
        variant="fullWidth"
      >
        {sections[userType].map((section) => (
          <Tab
            key={section}
            label={section}
            value={section}
            sx={{ textTransform: "none" }}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default ProfileSections;
